const $inject = ['$q', '$http', '$filter', '$rootScope', 'moment', 'APP_CONFIG', '$state'];

const lbHotelSearchService = function ($q, $http, $filter, $rootScope, moment, APP_CONFIG, $state) {
  let service = {};

  service.hasResults = false;
  service.resultsMaster = [];
  service.activeFilters = {};
  service.activeSort = undefined;
  service.results = {
    items: [],
    sorted: [],
    from: 0,
    pageSize: 30,
    matchedItem: null,
    relevanceOrder: false
  };

  service.get = get;
  service.getRates = getRates;
  service.getReviews = getReviews;
  service.getPolicy = getPolicy;
  service.bulkAddFilters = bulkAddFilters;
  service.filter = filter;
  service.sort = sort;
  service.clearResults = clearResults;
  service.setResults = setResults;
  service.setUnavailable = setUnavailable;
  service.getUniqueLocations = getUniqueLocations;
  service.getMinRateByRating = getMinRateByRating;
  service.getMaxRate = getMaxRate;
  service.getMinRate = getMinRate;
  service.getPolicyTooltipContent = getPolicyTooltipContent;
  service.getRoomRates = getRoomRates;
  service.computeRooms = computeRooms;


  function get(params, isPartial) {
    let deferred = $q.defer();

    let searchParams = {
      dateFrom: moment(params.DateFrom, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
      dateTo: moment(params.DateTo, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
      destinationLocationCode: params.Location.Code,
      paxCount: params.Passengers.length,
      searchIdentifier: params.Identifier,
      radiusDistance: params.Location.RadiusDistance,
      latitude: params.Location.Latitude,
      longitude: params.Location.Longitude,
      type: params.Location.Type,
      name: params.Location.Name
    };

    if ($state.params && $state.params.hotelId) searchParams.hotelId = $state.params.hotelId
    
    const endpoint = 'hotels';
    const apiUrl = APP_CONFIG.api[endpoint];

    $http.get(apiUrl, { params: searchParams, apiVersion: 21 })
      .then(function (res) {
        let data = res.data;
        data = processResults(data);

        if(!isPartial) {
          clearFilters();
          clearSort();
        }

        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function computeRooms(rooms) {
    return rooms.map((room) => {
      room.DepositRequired = _.some(room.Rates, { 'GuaranteeType' : 'DEP' });
      room.MinRate = _.reduce(room.Rates, function(rate, prevRate) {
        return rate.Amount < prevRate.Amount ? rate : prevRate;
      }, room.Rates[0]);
      return room;
    });
  }

  function processResults(results) {
    service.results.relevanceOrder = false;
    
    let processedResults = $filter('deepCopyFilter')(results);

    if(!processedResults.Hotels) {
      processedResults.Hotels = [];
    }

    processedResults.Hotels.forEach((hotel) => {
      hotel.Rooms = computeRooms(hotel.Rooms);

      if(hotel.Rooms && hotel.Rooms.length) {
        let cheapestRoom = _.minBy(hotel.Rooms, 'MinRate.Amount');
        let isDifferentCurrency = hotel.Rooms[0].Rates[0].BaseCurrency.Code != hotel.Rooms[0].Rates[0].Currency;

        hotel.cheapestShowApprox = isDifferentCurrency ? _.some([cheapestRoom], isApprox) : false;
        hotel.showApprox = isDifferentCurrency ? _.some(hotel.Rooms, isApprox) : false;
      }

      if (hotel.RelevanceOrder !== null && !service.results.relevanceOrder) {
        service.results.relevanceOrder = true;
      }
    });

    return processedResults;
  }

  function getRates(params) {
    let deferred = $q.defer();

    params.dateFrom = moment(params.dateFrom, APP_CONFIG.momentFormat.API).format('YYYY-MM-DD[T]HH:mm:ss');
    params.dateTo = moment(params.dateTo, APP_CONFIG.momentFormat.API).format('YYYY-MM-DD[T]HH:mm:ss');

    const apiUrl = APP_CONFIG.api.hotelRates;

    $http.get(apiUrl, { params: params })
      .then(function (res) {
        let data = res.data;
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function getReviews(hotelId) {
    let deferred = $q.defer();

    let searchParams = {
      hotelId: hotelId
    };

    const apiUrl = APP_CONFIG.api.hotelReviews;

    $http.get(apiUrl, { params: searchParams })
      .then(function (res) {
        let data = res.data;
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function getPolicy(params) {
    let deferred = $q.defer();

    const apiUrl = APP_CONFIG.api.hotelPolicy;

    $http.get(apiUrl, { params })
      .then(function (res) {
        let data = res.data;
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function clearFilters() {
    _.forIn(service.activeFilters, (filter) => {
      filter.settings.clear();
    });
  }

  function clearSort() {
    service.activeSort = undefined;
  }

  function clearResults() {
    service.hasResults = false;
    service.resultsMaster = [];
    service.results.items = [];
    service.results.matchedItem = null;
    service.results.from = 0;
  }

  function setResults(results) {
    service.hasResults = true;
    service.resultsMaster = results;
    service.results.items = results;
    service.results.matchedItem = _.find(results, 'MatchedItem');
  }

  function setUnavailable(results) {
    service.unavailable = results;
  }

  function getUniqueLocations(results) {
    let locations = [];

    _.forEach(results, (result) => {
      if(result.Area) {
        locations.push(result.Area);
      }
    });

    return _.uniq(locations);
  }

  function getMinRateByRating(results, ratings) {
    let resultsWithRate = _.filter(results, 'DisplayRate');

    let groupedResults = _.groupBy(resultsWithRate, (result) => {
      return result.Rating;
    });

    ratings.forEach((rating) => {
      rating.minRate = Math.round(_.min(_.map(groupedResults[rating.value], 'DisplayRate')));
    });

    return ratings;
  }

  function getMinRate(results) {
    return Math.ceil(_.min(_.compact(_.map(results, 'DisplayRate'))));
  }

  function getMaxRate(results) {
    return Math.ceil(_.max(_.compact(_.map(results, 'DisplayRate'))));
  }

  function bulkAddFilters(filters) {
    _.forOwn(filters, (filter, key) => {
      service.activeFilters[key] = filter;
    });

    $rootScope.$emit('hotelPaginationReset', true);
    
    filter();
  }

  function filter() {
    process();

    service.results.from = 0;
  }

  function sort(sortOption) {
    service.activeSort = sortOption;

    process();
  }

  function process() {
    let processedResults = _.clone(service.resultsMaster);

    _.forOwn(service.activeFilters, filter => {
      if (filter.settings.isActive()) {
        processedResults = $filter(filter.filterName)(processedResults, filter.settings, filter.handleResult);
      }
    });

    if(service.activeSort) {
      processedResults = _.sortBy(processedResults, (item) => {
        if(service.activeSort.expression === 'DisplayRate') {
          return item[service.activeSort.expression] || Number.MAX_VALUE;
        } else {
          return item[service.activeSort.expression];
        }
      });

      if(service.activeSort.isReverse) {
        processedResults = processedResults.reverse();
      }
    }

    service.results.items = processedResults;
  }

  function isApprox(room){
    return room.Provider.Brand === 'EAN' && _.some(room.Rates, {'PostPaid': true});
  }

  function getPolicyTooltipContent(rate) {
    var toolTipContent = '';

    if(rate.Cancellation) {
      toolTipContent += '<strong>' + rate.Cancellation + '</strong>';

      if(rate.Guarantee) {
        toolTipContent += '<span>' + rate.Guarantee + '</span>';
      }
    }

    return toolTipContent;
  }

  function getRoomRates(params) {
    let deferred = $q.defer();

    let searchParams = {
      dateFrom: moment(params.DateFrom, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
      dateTo: moment(params.DateTo, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
      destinationLocationCode: params.Location.Code,
      paxCount: params.Passengers.length,
      searchIdentifier: params.Identifier,
      radiusDistance: params.Location.RadiusDistance,
      latitude: params.Location.Latitude,
      longitude: params.Location.Longitude,
      HotelSupplierId: params.HotelSupplierId
    };

    const apiUrl = APP_CONFIG.api.hotelPartial;

    $http.get(apiUrl, { params: searchParams, apiVersion: 21 })
      .then(function (res) {
        let data = res.data;
        data.Rooms.forEach((room) => {
          room.MinRate = _.reduce(room.Rates, function(rate, prevRate) {
            return rate.Amount < prevRate.Amount ? rate : prevRate;
          }, room.Rates[0]);
        });
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  return service;
};

lbHotelSearchService.$inject = $inject;

export default lbHotelSearchService;



// WEBPACK FOOTER //
// ./src/services/lbHotelSearchService.js